// extracted by mini-css-extract-plugin
export default {"create":"CreateTextTask_create__MdM4-","text":"CreateTextTask_text__EJlkf","textarea":"CreateTextTask_textarea__sySXB"};